import { functions } from "common/config/Firebase";
import findClientByTask from "./sign/findClientByTask";

const sendReparadoByEmailUseCase = async (taskData) => {
  if (!taskData?.dni) {
    console.warn("⚠️ La tarea no tiene DNI asignado, no se envía email de reparado");
    return;
  }

  const clientData = await findClientByTask(taskData.dni);
  const to = clientData?.mail || taskData.mail;

  if (!to) {
    throw new Error("Este cliente no tiene email configurado");
  }

  const sendDocumentEmail = functions.httpsCallable("sendDocumentEmail");

  const payload = {
    to,
    type: "reparado",
    pdfUrl: null,
    filename: null,
    meta: {
      repairNumber: taskData.reference,
      deviceName: taskData.deviceName,
      serialNumber: taskData.imei || taskData.serialNumber || "",
    },
  };

  await sendDocumentEmail(payload);
};

export default sendReparadoByEmailUseCase;
